/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Logo } from '@americanexpress/dls-react';
import registerStyles from '../../styles/registerStyles';
import Banner from './Banner/Banner';

/**
 * Two-column registration shell: the sign-up banner on the left and the
 * flow-specific content (Welcome / result pages) on the right. Shared by the
 * Register welcome journey and the enrollment-completed result page.
 *
 * `centerContent` vertically centers the content (used by the single-message
 * result pages); the Welcome journey keeps its default top-aligned flow.
 */
const RegisterLayout = ({ children, centerContent }) => (
  <div className="pad" css={registerStyles['.pageContainer']}>
    <div id="container" css={registerStyles['.backgroundContainer']}>
      <div id="left-container" css={registerStyles['.banner']}>
        <Banner />
      </div>
      <div
        id="right-container"
        className="dls-white-bg"
        css={[
          registerStyles['.registration'],
          centerContent && registerStyles['.registrationCenteredColumn'],
        ]}
      >
        <Logo
          alt="American Express"
          size=""
          styleType="bluebox-solid"
          css={centerContent ? registerStyles['.registrationLogoFloat'] : undefined}
        />
        {centerContent ? (
          <div css={registerStyles['.registrationCentered']}>{children}</div>
        ) : (
          children
        )}
      </div>
    </div>
  </div>
);

RegisterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  centerContent: PropTypes.bool,
};

RegisterLayout.defaultProps = {
  centerContent: false,
};

export default RegisterLayout;
